/**
 * GovernanceContextPage - Governance context management
 *
 * Surfaces the GovernanceContextManager from @ferp/workflow-forms for admin/architect users.
 * Provides management of governance execution context and variable scoping.
 *
 * Route: /admin/governance-context
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconAdjustments } from '@tabler/icons-react';

import { GovernanceContextManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function GovernanceContextPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="lime">
            <IconAdjustments size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Governance Context</Title>
            <Text size="sm" c="dimmed">
              Manage governance execution context and variable scoping
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <GovernanceContextManager />
    </Container>
  );
}

export default GovernanceContextPage;
